<div class="form-group" [formGroup]="form" (change)="onSelect()">
  <select formControlName="bool" class="form-control">
    <option [value]="null">{{ 'KENDO_CUSTOM_BOOLEAN_FILTER.ALL' | translate }}</option>
    <option [value]="'1'">{{ 'KENDO_CUSTOM_BOOLEAN_FILTER.TRUE' | translate }}</option>
    <option [value]="'0'">{{ 'KENDO_CUSTOM_BOOLEAN_FILTER.FALSE' | translate }}</option>
  </select>
</div>
